import { render, staticRenderFns } from "./base-view.vue?vue&type=template&id=7fd1c815&scoped=true&"
import script from "./base-view.vue?vue&type=script&lang=js&"
export * from "./base-view.vue?vue&type=script&lang=js&"
import style0 from "./base-view.vue?vue&type=style&index=0&id=7fd1c815&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd1c815",
  null
  
)

export default component.exports